function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var $625ad1e1f4c43bc1$exports = require("./CalendarDate.main.js");
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {
    get: v,
    set: s,
    enumerable: true,
    configurable: true
  });
}
$parcel$export(module.exports, "IslamicCivilCalendar", function () {
  return $ecb2c4cc8c9aae25$export$2066795aadd37bfc;
});
$parcel$export(module.exports, "IslamicTabularCalendar", function () {
  return $ecb2c4cc8c9aae25$export$37f0887f2f9d22f7;
});
$parcel$export(module.exports, "IslamicUmalquraCalendar", function () {
  return $ecb2c4cc8c9aae25$export$5baab4758c231076;
});
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // Portions of the code in this file are based on code from ICU.
// Original licensing can be found in the NOTICE file in the root directory of this source tree.

var $ecb2c4cc8c9aae25$var$CIVIL_EPOC = 1948440; // CE 622 July 16 Friday (Julian calendar) / CE 622 July 19 (Gregorian calendar)
var $ecb2c4cc8c9aae25$var$ASTRONOMICAL_EPOC = 1948439; // CE 622 July 15 Thursday (Julian calendar)
var $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START = 1300;
var $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_END = 1600;
var $ecb2c4cc8c9aae25$var$UMALQURA_START_DAYS = 460322;
function $ecb2c4cc8c9aae25$var$islamicToJulianDay(epoch, year, month, day) {
  return day + Math.ceil(29.5 * (month - 1)) + (year - 1) * 354 + Math.floor((3 + 11 * year) / 30) + epoch - 1;
}
function $ecb2c4cc8c9aae25$var$julianDayToIslamic(calendar, epoch, jd) {
  var year = Math.floor((30 * (jd - epoch) + 10646) / 10631);
  var month = Math.min(12, Math.ceil((jd - (29 + $ecb2c4cc8c9aae25$var$islamicToJulianDay(epoch, year, 1, 1))) / 29.5) + 1);
  var day = jd - $ecb2c4cc8c9aae25$var$islamicToJulianDay(epoch, year, month, 1) + 1;
  return new (0, $625ad1e1f4c43bc1$exports.CalendarDate)(calendar, year, month, day);
}
function $ecb2c4cc8c9aae25$var$isLeapYear(year) {
  return (14 + 11 * year) % 30 < 11;
}
var $ecb2c4cc8c9aae25$export$2066795aadd37bfc = /*#__PURE__*/function () {
  function $ecb2c4cc8c9aae25$export$2066795aadd37bfc() {
    _classCallCheck(this, $ecb2c4cc8c9aae25$export$2066795aadd37bfc);
    this.identifier = 'islamic-civil';
  }
  return _createClass($ecb2c4cc8c9aae25$export$2066795aadd37bfc, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      return $ecb2c4cc8c9aae25$var$julianDayToIslamic(this, $ecb2c4cc8c9aae25$var$CIVIL_EPOC, jd);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return $ecb2c4cc8c9aae25$var$islamicToJulianDay($ecb2c4cc8c9aae25$var$CIVIL_EPOC, date.year, date.month, date.day);
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      var length = 29 + date.month % 2;
      if (date.month === 12 && $ecb2c4cc8c9aae25$var$isLeapYear(date.year)) length++;
      return length;
    }
  }, {
    key: "getMonthsInYear",
    value: function getMonthsInYear() {
      return 12;
    }
  }, {
    key: "getDaysInYear",
    value: function getDaysInYear(date) {
      return $ecb2c4cc8c9aae25$var$isLeapYear(date.year) ? 355 : 354;
    }
  }, {
    key: "getYearsInEra",
    value: function getYearsInEra() {
      // 9999 gregorian
      return 9665;
    }
  }, {
    key: "getEras",
    value: function getEras() {
      return ['AH'];
    }
  }]);
}();
var $ecb2c4cc8c9aae25$export$37f0887f2f9d22f7 = /*#__PURE__*/function (_$ecb2c4cc8c9aae25$ex) {
  function $ecb2c4cc8c9aae25$export$37f0887f2f9d22f7() {
    var _this;
    _classCallCheck(this, $ecb2c4cc8c9aae25$export$37f0887f2f9d22f7);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, $ecb2c4cc8c9aae25$export$37f0887f2f9d22f7, [].concat(args)), _this.identifier = 'islamic-tbla';
    return _this;
  }
  _inherits($ecb2c4cc8c9aae25$export$37f0887f2f9d22f7, _$ecb2c4cc8c9aae25$ex);
  return _createClass($ecb2c4cc8c9aae25$export$37f0887f2f9d22f7, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      return $ecb2c4cc8c9aae25$var$julianDayToIslamic(this, $ecb2c4cc8c9aae25$var$ASTRONOMICAL_EPOC, jd);
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      return $ecb2c4cc8c9aae25$var$islamicToJulianDay($ecb2c4cc8c9aae25$var$ASTRONOMICAL_EPOC, date.year, date.month, date.day);
    }
  }]);
}($ecb2c4cc8c9aae25$export$2066795aadd37bfc); // Generated by scripts/generate-umalqura.js
var $ecb2c4cc8c9aae25$var$UMALQURA_DATA = 'qgpUDckO1AbqBmwDrQpVBakGkgepC9QF2gpcBS0NlQZKB1QLagutBa4ETwoXBYsGpQbVCtYCWwmdBE0KJg2VDawFtgm6AlsKKwWVCsoG6Qr0AnYJtgJWCcoKpAvSC9kF3AJtCU0FpQpSC6ULtAW2CVcFlwJLBaMGUgdlC2oFqworBZUMSg2lDcoF1gpXCasESwmlClILagt1BXYCtwhbBFUFqQW0BdoJ3QRuAjYJqgpUDbIN1QXaAlsJqwRVCkkLZAtxC7QFtQpVCiUNkg7JDtQG6QprCasEkwpJDaQNsg25CroEWworBZUKKgtVC1wFvQQ9Ah0JlQpKC1oLbQW2AjsJmwRVBqkGVAdqC2wFrQpVBSkLkgupC9QF2gpaBasKlQVJB2QHqgu1BbYCVgpNDiULUgtqC60FrgIvCZcESwalBqwG1gpdBZ0ETQoWDZUNqgW1BdoCWwmtBJUFygbkBuoK9QS2AlYJqgpUC9IL2QXqAm0JrQSVCkoLpQuyBbUJ1gSXCkcFkwZJB1ULagVrCisFiwpGDaMNygXWCtsEawJLCaUKUgtpC3UFdgG3CFsCKwVlBbQF2gntBG0BtgimClINqQ3UBdoKWwmrBFMGKQdiB6kLsgW1ClUFJQuSDckO0gbpCmsFqwRVCikNVA2qDbUJugQ7CpsETQqqCtUK2gJdCV4ELgqaDFUNsga5BroEXQotBZUKUguoC7QLuQXaAloJSgukDdEO6AZqC20FNQWVBkoNqA3UDdoGWwWdAisGFQtKC5ULqgWuCi4JjwwnBZUGqgbWCl0FnQI=';
var $ecb2c4cc8c9aae25$var$UMALQURA_MONTHLENGTH;
var $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START_TABLE;
function $ecb2c4cc8c9aae25$var$umalquraYearStart(year) {
  return $ecb2c4cc8c9aae25$var$UMALQURA_START_DAYS + $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START_TABLE[year - $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START];
}
function $ecb2c4cc8c9aae25$var$umalquraMonthLength(year, month) {
  var idx = year - $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START;
  var mask = 0x01 << 11 - (month - 1);
  if (($ecb2c4cc8c9aae25$var$UMALQURA_MONTHLENGTH[idx] & mask) === 0) return 29;else return 30;
}
function $ecb2c4cc8c9aae25$var$umalquraMonthStart(year, month) {
  var day = $ecb2c4cc8c9aae25$var$umalquraYearStart(year);
  for (var i = 1; i < month; i++) day += $ecb2c4cc8c9aae25$var$umalquraMonthLength(year, i);
  return day;
}
function $ecb2c4cc8c9aae25$var$umalquraYearLength(year) {
  return $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START_TABLE[year + 1 - $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START] - $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START_TABLE[year - $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START];
}
var $ecb2c4cc8c9aae25$export$5baab4758c231076 = /*#__PURE__*/function (_$ecb2c4cc8c9aae25$ex2) {
  function $ecb2c4cc8c9aae25$export$5baab4758c231076() {
    var _this2;
    _classCallCheck(this, $ecb2c4cc8c9aae25$export$5baab4758c231076);
    _this2 = _callSuper(this, $ecb2c4cc8c9aae25$export$5baab4758c231076), _this2.identifier = 'islamic-umalqura';
    if (!$ecb2c4cc8c9aae25$var$UMALQURA_MONTHLENGTH) $ecb2c4cc8c9aae25$var$UMALQURA_MONTHLENGTH = new Uint16Array(Uint8Array.from(atob($ecb2c4cc8c9aae25$var$UMALQURA_DATA), function (c) {
      return c.charCodeAt(0);
    }).buffer);
    if (!$ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START_TABLE) {
      $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START_TABLE = new Uint32Array($ecb2c4cc8c9aae25$var$UMALQURA_YEAR_END - $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START + 1);
      var yearStart = 0;
      for (var year = $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START; year <= $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_END; year++) {
        $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START_TABLE[year - $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START] = yearStart;
        for (var i = 1; i <= 12; i++) yearStart += $ecb2c4cc8c9aae25$var$umalquraMonthLength(year, i);
      }
    }
    return _this2;
  }
  _inherits($ecb2c4cc8c9aae25$export$5baab4758c231076, _$ecb2c4cc8c9aae25$ex2);
  return _createClass($ecb2c4cc8c9aae25$export$5baab4758c231076, [{
    key: "fromJulianDay",
    value: function fromJulianDay(jd) {
      var days = jd - $ecb2c4cc8c9aae25$var$CIVIL_EPOC;
      var startDays = $ecb2c4cc8c9aae25$var$umalquraYearStart($ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START);
      var endDays = $ecb2c4cc8c9aae25$var$umalquraYearStart($ecb2c4cc8c9aae25$var$UMALQURA_YEAR_END);
      if (days < startDays || days > endDays) return _superPropGet($ecb2c4cc8c9aae25$export$5baab4758c231076, "fromJulianDay", this, 3)([jd]);else {
        var y = $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START - 1;
        var m = 1;
        var d = 1;
        while (d > 0) {
          y++;
          d = days - $ecb2c4cc8c9aae25$var$umalquraYearStart(y) + 1;
          var yearLength = $ecb2c4cc8c9aae25$var$umalquraYearLength(y);
          if (d === yearLength) {
            m = 12;
            break;
          } else if (d < yearLength) {
            var monthLength = $ecb2c4cc8c9aae25$var$umalquraMonthLength(y, m);
            m = 1;
            while (d > monthLength) {
              d -= monthLength;
              m++;
              monthLength = $ecb2c4cc8c9aae25$var$umalquraMonthLength(y, m);
            }
            break;
          }
        }
        return new (0, $625ad1e1f4c43bc1$exports.CalendarDate)(this, y, m, days - $ecb2c4cc8c9aae25$var$umalquraMonthStart(y, m) + 1);
      }
    }
  }, {
    key: "toJulianDay",
    value: function toJulianDay(date) {
      if (date.year < $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START || date.year > $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_END) return _superPropGet($ecb2c4cc8c9aae25$export$5baab4758c231076, "toJulianDay", this, 3)([date]);
      return $ecb2c4cc8c9aae25$var$CIVIL_EPOC + $ecb2c4cc8c9aae25$var$umalquraMonthStart(date.year, date.month) + (date.day - 1);
    }
  }, {
    key: "getDaysInMonth",
    value: function getDaysInMonth(date) {
      if (date.year < $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START || date.year > $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_END) return _superPropGet($ecb2c4cc8c9aae25$export$5baab4758c231076, "getDaysInMonth", this, 3)([date]);
      return $ecb2c4cc8c9aae25$var$umalquraMonthLength(date.year, date.month);
    }
  }, {
    key: "getDaysInYear",
    value: function getDaysInYear(date) {
      if (date.year < $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_START || date.year > $ecb2c4cc8c9aae25$var$UMALQURA_YEAR_END) return _superPropGet($ecb2c4cc8c9aae25$export$5baab4758c231076, "getDaysInYear", this, 3)([date]);
      return $ecb2c4cc8c9aae25$var$umalquraYearLength(date.year);
    }
  }]);
}($ecb2c4cc8c9aae25$export$2066795aadd37bfc);